import { render } from "./WalletLogRecords.vue?vue&type=template&id=19cd2142&scoped=true"
import script from "./WalletLogRecords.vue?vue&type=script&lang=js"
export * from "./WalletLogRecords.vue?vue&type=script&lang=js"

import "./WalletLogRecords.vue?vue&type=style&index=0&id=19cd2142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cd2142"]])

export default __exports__